import React from "react";
import { AuthProvider } from './contexts/AuthContext';
import { PartnerAuthProvider } from './contexts/PartnerAuthContext';
import Routes from './Routes';

function App() {
  return (
    <AuthProvider>
      <PartnerAuthProvider>
        <Routes />
      </PartnerAuthProvider>
    </AuthProvider>
  );
}

export default App;